module.exports = __WEBPACK_EXTERNAL_MODULE_17__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/geom/Matrix","root":["openfl","geom","Matrix"],"commonjs":"openfl/geom/Matrix","commonjs2":"openfl/geom/Matrix"}
// module id = 17
// module chunks = 0